import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import {
  ApplicationConfig,
  inject,
  LOCALE_ID,
  provideAppInitializer
} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {MAT_DATE_LOCALE, provideNativeDateAdapter} from '@angular/material/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {MatPaginatorIntl} from '@angular/material/paginator'
import {
  provideRouter,
  withHashLocation,
  withInMemoryScrolling
} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {SpbPaginatorSv} from '@sparbanken-syd/sparbanken-syd-theme'
import {environment} from '../environments/environment'
import {routes} from './app.routes'
import {ADMIN_MODULE, ADMIN_ROLE_NAME} from './application/types'

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: [ADMIN_ROLE_NAME]
}


registerLocaleData(localeFr, 'fr')
export const appConfig: ApplicationConfig = {
  providers: [
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        text: 'För att komma igång behöver du först logga in med ditt BankID',
        buttonText: 'Logga in med BankID',
        route: ['/', ADMIN_MODULE]
      }
    },
    provideAppInitializer(() => inject(ConfigService).bootstrap()),
    {provide: LOCALE_ID, useValue: 'fr'},
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        floatLabel: 'always',
        hideRequiredMarker: true,
        appearance: 'outline',
        subscriptSizing: 'dynamic'
      }
    },
    provideRouter(routes, withHashLocation(), withInMemoryScrolling({anchorScrolling: 'enabled'})),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    ),
    {
      provide: MAT_DATE_LOCALE, useValue: 'sv'
    },
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}},
    provideNativeDateAdapter(),
    {provide: MatPaginatorIntl, useClass: SpbPaginatorSv}
  ]
}